import {
  TextInput,
  required,
  useTranslate,
  SimpleForm,
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { Styles } from "@material-ui/styles/withStyles";
import { Typography } from "@material-ui/core";
import { MediaInputField } from "../../../lib/components";
import { MAX_RECORDS_PER_PAGE } from "../../../lib/common";
import { RESOURCE_NAME_PURCHASE_GROUPS } from "./constants";

export const styles: Styles<Theme, any> = {
  number: { display: "block" },
  name: { display: "block" },
  description: { display: "block" },
  formClass: {
    width: "75%",
  },
};
const useStyles = makeStyles(styles);

const PurchaseGroupForm = ({ isEdit = false, ...rest }) => {
  const classes = useStyles(rest);
  return (
    <SimpleForm
      variant="filled"
      className={classes.formClass}
      warnWhenUnsavedChanges
      {...rest}
    >
      <SectionTitle label="resources.purchaseGroups.fieldGroups.PurchaseGroupDetaills" />
      <TextInput
        autoFocus
        source="number"
        label="resources.purchaseGroups.fields.number"
        helperText="resources.purchaseGroups.help.number"
        formClassName={classes.number}
        validate={[required()]}
        fullWidth
      />

      <TextInput
        source="name"
        label="resources.purchaseGroups.fields.name"
        helperText="resources.purchaseGroups.help.name"
        formClassName={classes.name}
        validate={[required()]}
        fullWidth
      />

      <RichTextInput
        source="description"
        helperText="resources.purchaseGroups.help.description"
        formClassName={classes.description}
        label="resources.purchaseGroups.fields.description"
      />
      <ReferenceInput
        source="parentId"
        label="resources.purchaseGroups.fields.parentId"
        fullWidth
        reference={RESOURCE_NAME_PURCHASE_GROUPS}
        perPage={MAX_RECORDS_PER_PAGE}
        sort={{ field: "name", order: "ASC" }}
        filter={isEdit ? { excludeIds: [rest?.id] } : {}}
        key="parentId"
      >
        <AutocompleteInput
          optionText="displayLabel"
          resettable={true}
          allowEmpty={false}
          helperText="resources.purchaseGroups.help.parentId"
        />
      </ReferenceInput>

      <MediaInputField showUploadedFiles={isEdit} />
    </SimpleForm>
  );
};
const SectionTitle = ({ label }: { label: string }) => {
  const translate = useTranslate();

  return (
    <Typography variant="h6" gutterBottom>
      {translate(label)}
    </Typography>
  );
};

export { PurchaseGroupForm };
